import styled from 'styled-components';
import { Input } from 'reactstrap';

export const IconSearch = styled.i`
 
`;

export const InputSearch = styled(Input)`
`;
